module.exports = __webpack_public_path__ + "img/qr-icon.4f78cab0.svg";